// /**
//  * Warehouses - list
//  */

// React
import React from 'react';
import {Link} from 'react-router-dom';
import HeaderBuilder from '../../../utils/headerBuilder';
// UI
import theme from '../../../theme';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiPencilOutline,
  mdiCheck,
  mdiFileDocumentOutline,
  mdiMapMarkerMultipleOutline,
} from '@mdi/js';

// Helper
import {formaterPhoneNumber} from '../../../utils/helpers';

// Type
import {Warehouse} from '../interfaces';

type Data = Warehouse;
type Props = {
  data: any;
  handleOpenConfirmDisable: (id: number) => void;
  handleOpenConfirmActive: (id: number) => void;
  handleOpen: (id: number, type: string) => void;
  changeStatus: any;
};

type Ord = 'asc' | 'desc';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [dense] = React.useState(false);
  const {handleOpenConfirmDisable, handleOpenConfirmActive, handleOpen} = props;

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <HeaderBuilder
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data.length}
            filterVal={props.filterVal}
            onFilterValue={(filtervalues: any) => {
              props.onFilterValue(filtervalues);
            }}
            head={props.head}
            removeFilterHandler={props.removeFilterHandler}
            haveAction={true}
            filterLabelTranslator={props.filterLabelTranslator}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow key={index}>
                    <TableCell align="center">{row.id}</TableCell>
                    <TableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.name}
                    </TableCell>

                    <TableCell align="center">
                      {formaterPhoneNumber(row.province)}
                    </TableCell>
                    <TableCell align="center">{row.city}</TableCell>
                    <TableCell align="center">{row.capacity}</TableCell>

                    <TableCell align="right">
                      <Link
                        to={`/warehouses/details/${row.id}?partnerId=${row.parentId}`}
                      >
                        <IconButton
                          aria-label="details"
                          size="small"
                          title="جزئیات سفارش"
                          data-cy="details"
                        >
                          <Icon
                            path={mdiFileDocumentOutline}
                            size={1}
                            color={theme.palette.green.main}
                          />
                        </IconButton>
                      </Link>

                      {/* <IconButton
                        title="گزارش موجودی"
                        size="small"
                        onClick={() => handleOpen(row.id, 'inventory')}
                      >
                        <Icon path={mdiCalendarSearch} size={1} />
                      </IconButton>
                      <Link to={`/inventry-items/${row.id}`}>
                        <IconButton title="اقلام" size="small">
                          <Icon path={mdiClipboardListOutline} size={1} />
                        </IconButton>
                      </Link> */}

                      <Link to={`/warehouses/children/${row.id}`}>
                        <IconButton title="لیست مراکز" size="small">
                          <Icon path={mdiMapMarkerMultipleOutline} size={1} />
                        </IconButton>
                      </Link>
                      <IconButton
                        title="ویرایش"
                        size="small"
                        onClick={() => handleOpen(row.id, 'edit')}
                      >
                        <Icon
                          path={mdiPencilOutline}
                          size={1}
                          color={theme.palette.blue.main}
                        />
                      </IconButton>

                      <>
                        {row.status === 'SUSPENDED' ||
                        row.status === 'REGISTERED' ? (
                          <IconButton
                            aria-label="cancele"
                            title=" فعال کردن انبار "
                            size="small"
                            onClick={() => handleOpenConfirmActive(row.id)}
                          >
                            <Icon
                              path={mdiCheck}
                              size={1}
                              color={theme.palette.green.main}
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            aria-label="cancele"
                            title="غیر فعال کردن انبار "
                            size="small"
                            onClick={() => handleOpenConfirmDisable(row.id)}
                          >
                            <Icon
                              path={mdiClose}
                              size={1}
                              color={theme.palette.error.main}
                            />
                          </IconButton>
                        )}
                      </>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
